import { Row } from 'Components/Grid';
import { useTranslation } from 'react-i18next';
import { MainContent, TitleMainContent } from '../styles';
import { capitalizeWords } from 'utils/string_utils';

const AreaData = ({ areaData }) => {
  return (
    <>
      <MainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2">{capitalizeWords(areaData.name)}</Row>
      </MainContent>
      <MainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2" justifyContent="center">
          {areaData.personalDataQuantity}
        </Row>
      </MainContent>
      <MainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2" justifyContent="center">
          {areaData.sensitivePersonalDataQuantity}
        </Row>
      </MainContent>
      <MainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2" justifyContent="center">
          {areaData.legalBaseQuantity}
        </Row>
      </MainContent>
    </>
  );
};

export const IndicatorAreaDatas = ({ indicatorAreaDatas }) => {
  const { t } = useTranslation('mapping');
  return (
    <Row className="mt-4">
      <TitleMainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.areaName')}</Row>
      </TitleMainContent>
      <TitleMainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.personalDataPlural')}</Row>
      </TitleMainContent>
      <TitleMainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.sensitivePersonalDataPlural')}</Row>
      </TitleMainContent>
      <TitleMainContent xs={3} sm={3} md={3}>
        <Row className="pl-3 font-weight-bold mb-2">{t('ropa.executiveSummary.legalBasesPlural')}</Row>
      </TitleMainContent>
      {indicatorAreaDatas &&
        indicatorAreaDatas.map((item, key) => <AreaData key={`area-data-${key}`} areaData={item} />)}
    </Row>
  );
};
